import React from 'react';
import styles from './simple_spinner.module.scss';

interface Props {
  display?: boolean;
  size?: number;
  opacity?: number;
}

const SimpleSpinner = ({display = true, size = 1, opacity = 0 }: Props) => {
  if (!display) return null;

  return (
    <div className={styles.container} style={{opacity}}>
      <div
        className={styles.spinner}
        style={{ width: `${size}rem`, height: `${size}rem`, opacity}} />
    </div>
  );
};

export default SimpleSpinner;
